import { useNavigate } from '@tanstack/react-router';
import { ForwardedRef, ReactNode, forwardRef } from 'react';
import { cn } from '@shared/util/classnames';
import { Button, ButtonProps } from './Button';

interface RouteButtonProps extends ButtonProps {
  children: ReactNode;
  to: string;
  params?: Record<string, string>;
}

export const RouteButton = forwardRef(RouteButtonWithRef);
RouteButton.displayName = 'RouteButton';

function RouteButtonWithRef(props: RouteButtonProps, ref: ForwardedRef<HTMLButtonElement | null>) {
  const { children, to, params, className, ...buttonProps } = props;
  const navigate = useNavigate();

  function handleNavigate() {
    void navigate({ to, params });
  }

  return (
    <Button
      ref={ref}
      {...buttonProps}
      onPress={handleNavigate}
      className={cn('text-coast-purple', className)}
    >
      {children}
    </Button>
  );
}
